import * as Types from '../types-hasura.generated';

import { ClientError } from "graphql-request";
import { ArtworkEventFragment, UserFragment, ArtworkFragment, CollectionFragment } from '../hasura-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { hasuraFetcher } from 'lib/clients/hasura-client';
export type NftProvenanceVariables = Types.Exact<{
  contractAddress: Types.Scalars['String'];
  tokenId: Types.Scalars['numeric'];
  eventTypes: Array<Types.Scalars['event_eventtype_enum']> | Types.Scalars['event_eventtype_enum'];
}>;


export type NftProvenance = { saleEvents: Array<Pick<Types.Event, 'id' | 'eventType' | 'data' | 'blockTimestamp' | 'publicKey' | 'tokenId'>>, events: Array<(
    Pick<Types.Event, 'id' | 'eventType' | 'data' | 'blockTimestamp' | 'publicKey' | 'tokenId'>
    & { user: Pick<Types.User, 'bio' | 'coverImageUrl' | 'createdAt' | 'isAdmin' | 'links' | 'moderationStatus' | 'name' | 'profileImageUrl' | 'publicKey' | 'username'> }
  )> };



export const NftProvenanceDocument = /*#__PURE__*/ `
    query NftProvenance($contractAddress: String!, $tokenId: numeric!, $eventTypes: [event_eventtype_enum!]!) {
  saleEvents: event(
    limit: 1
    order_by: {blockTimestamp: desc_nulls_last}
    where: {contractAddress: {_eq: $contractAddress}, eventType: {_eq: "FIXED_PRICE_SALE_CREATE"}}
  ) {
    ...ArtworkEventFragment
  }
  events: event(
    order_by: {blockTimestamp: desc_nulls_last}
    where: {contractAddress: {_eq: $contractAddress}, tokenId: {_eq: $tokenId}, eventType: {_in: $eventTypes}}
  ) {
    ...ArtworkEventFragment
    user {
      ...UserFragment
    }
  }
}
    ${ArtworkEventFragment}
${UserFragment}`;

export const useNftProvenance = <
      TData = NftProvenance,
      TError = ClientError
    >(
      variables: NftProvenanceVariables,
      options?: Omit<UseQueryOptions<NftProvenance, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<NftProvenance, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<NftProvenance, TError, TData>(
      {
    queryKey: ['NftProvenance', variables],
    queryFn: hasuraFetcher<NftProvenance, NftProvenanceVariables>(NftProvenanceDocument, variables),
    ...options
  }
    )};

useNftProvenance.getKey = (variables: NftProvenanceVariables) => ['NftProvenance', variables];

export const useInfiniteNftProvenance = <
      TData = InfiniteData<NftProvenance>,
      TError = ClientError
    >(
      variables: NftProvenanceVariables,
      options: Omit<UseInfiniteQueryOptions<NftProvenance, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<NftProvenance, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<NftProvenance, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['NftProvenance.infinite', variables],
      queryFn: (metaData) => hasuraFetcher<NftProvenance, NftProvenanceVariables>(NftProvenanceDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteNftProvenance.getKey = (variables: NftProvenanceVariables) => ['NftProvenance.infinite', variables];


useNftProvenance.fetcher = (variables: NftProvenanceVariables, options?: RequestInit['headers']) => hasuraFetcher<NftProvenance, NftProvenanceVariables>(NftProvenanceDocument, variables, options);
